import { useWorkspace } from '../state/workspace.js';

/** Open-file tabs with dirty markers and a close affordance. */
export function Tabs() {
  const tabs = useWorkspace((s) => s.tabs);
  const files = useWorkspace((s) => s.files);
  const closeTab = useWorkspace((s) => s.closeTab);
  const saveFile = useWorkspace((s) => s.saveFile);
  const active = tabs.at(-1) ?? null;

  if (tabs.length === 0) return null;

  return (
    <div className="tabs" role="tablist">
      {tabs.map((path) => {
        const file = files[path];
        const dirty = file ? file.content !== file.savedContent : false;
        const name = path.split('/').pop() ?? path;
        return (
          <div
            key={path}
            className={`tab${path === active ? ' is-active' : ''}`}
            role="tab"
            aria-selected={path === active}
            title={path}
          >
            <button
              type="button"
              className="tab-label"
              onClick={() => {
                // Re-clicking an open tab makes it active again.
                if (path !== active) {
                  useWorkspace.setState((state) => ({
                    tabs: [...state.tabs.filter((t) => t !== path), path],
                  }));
                }
              }}
              onDoubleClick={() => void saveFile(path)}
            >
              {dirty && <span className="dot-dirty" aria-label="unsaved" />}
              {name}
            </button>
            <button
              type="button"
              className="tab-close"
              aria-label={`Close ${name}`}
              onClick={() => closeTab(path)}
            >
              ×
            </button>
          </div>
        );
      })}
      <div className="tabs-spacer" />
      <button
        type="button"
        className="tab-save"
        onClick={() => active && void saveFile(active)}
        disabled={!active}
        title="Save (Ctrl+S)"
      >
        Save
      </button>
    </div>
  );
}